import updateSIGSDataOnClickAction from '../actions/updateSIGSDataOnClickAction';
import { mutator } from 'satcheljs';

export default mutator(updateSIGSDataOnClickAction, actionMessage => {
    const { composeViewState, timeClicked, clickIndex } = actionMessage;

    if (composeViewState) {
        composeViewState.smartPillViewState.smartReplyComposeSIGSData = {
            isSmartSuggestionsClicked: true,
            suggestionsClickedTime: timeClicked,
            clickIndex: clickIndex,
        };
    }
});
